import { capitalize } from "../helpers/string/capitalize";
import { TitleWithStyles } from "../ui/layout";

const errorsList = {
  "403": {
    title: "Access denied",
    message:
      "You don’t have permission to access this page. Please ask your administrator to provide you the access or go back to the previous page.",
  },
  "404": {
    title: "Page not found",
    message:
      "The page you are looking for can be changed, removed or the address may contain spelling mistakes.",
  },
  "500": {
    title: "Internal server error",
    message:
      "The page is not accessible at the moment. Please try again later.",
  },
  "503": {
    title: "Service unavailable",
    message:
      "The page is not accessible at the moment. Please check your internet connection or try again later.",
  },
};

export const pageError = (errorCode?: string) => {
  const error = (errorCode as keyof typeof errorsList)
    ? errorsList[errorCode as keyof typeof errorsList]
    : errorsList["500"];
  return (
    <>
      <TitleWithStyles title={capitalize(error.title)} />
      <p className="text-primary mt-4">{error.message}</p>
      <a
        className="text-primary mt-6 underline hover:text-stone-700 dark:text-stone-400 dark:hover:text-stone-500"
        href="/"
      >
        Go to the main page
      </a>
    </>
  );
};
